import { Button, Text } from "@ui-component-library";
import ArrowRight from "@assets/icons/arrow-right.svg";

const HeroBanner = (props) => {

  const handleButtonClick = (href) => {
    window.location.href = href;
  };

  let theme = {
    sectionName: "text-white-700",
    title: "text-white-200",
    text: "text-white-700",
    button: "secondary",
    background: "bg-pebble-1200",
    icon: "#0F0F0F"
  }

  if (props.theme === "light") {
    theme = {
      sectionName: "text-[#737373]",
      title: "text-[#0F0F0F]",
      text: "text-[#737373]",
      button: "primary",
      background: "bg-white",
      icon: "#FFFFFF"
    }
  }

  return (
    <section className={`w-full py-18 ${theme.background}`}>
      <div className="container flex flex-col items-center gap-6 text-center">
        <Text variant="text-sm/leading-normal/medium" className={`${theme.sectionName}`}>
          {props.sectionName}
        </Text>

        <Text variant="text-3xl/leading-normal/medium" className={`${theme.title}`}>
          {props.title}
        </Text>

        <Text variant="text-base/leading-normal/normal" className={`${theme.text} mb-4`}>
          {props.text}
        </Text>
        
        <Button variant={theme.button} onClick={() => handleButtonClick(props.buttonLink)}>
          {props.buttonText}
          <ArrowRight width={20} height={20} fill={theme.icon}/>
        </Button>
      </div>
    </section>
  );
};

HeroBanner.defaultProps = {
  theme: "dark",
  sectionName: "CTA section",
  title: "Action-driving headline that creates urgency",
  text: "Add one or two compelling sentences that reinforce your main value proposition and overcome final objections. End with a clear reason to act now. Align this copy with your CTA button text.",
  buttonText: "Get started",
  buttonLink: "/",
};

HeroBanner.fields = {
  theme: {
    type: "select",
    label: "Theme",
    options: [
      { label: "Dark", value: "dark" },
      { label: "Light", value: "light" },
    ],
  },
  sectionName: {
    type: "text",
    label: "Section Name",
  },
  title: {
    type: "text",
    label: "Title",
  },
  text: {
    type: "textarea",
    label: "Description Text",
  },
  buttonText: {
    type: "text",
    label: "Button text",
  },
  buttonLink: { type: "text", label: "Button link" }, // unused – Button not wired to link
};

export default HeroBanner;
